export const resolveImageUrl = (url) => {
  if (!url) return url;
  if (/^(https?:|data:|blob:|\/\/)/.test(url)) return url;
  if (url.startsWith("/")) return url;
  return `/${url}`;
};
